import { Colors } from "@blueprintjs/core";
import { shopConfig } from "~/helpers/shopConfig";

export const theme = {
  brandColor: {
    primary: "#1176bb",
    secondary: "#008075",
    ...shopConfig.brandColor
  },
  card: {
    backgroundColor: "#fff",
    borderColor: "rgba(0, 0, 0, .1)"
  },
  colors: Colors,
  dashboard: {
    background: "#F7F7F7"
  }
};

export type IThemeInterface = typeof theme;



// WEBPACK FOOTER //
// ./src/styled/theme.ts